import { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';

export default function SiteLayout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteNavbar />
      <main className="flex-1">{children}</main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}